import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolgatpuritaxi() {



  const cardData = {




keyword: "Pune to Igatpuri Taxi",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Igatpuri Taxi Service for families, couples, corporate travelers, senior citizens, and groups planning a scenic journey to Igatpuri. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for one-way trips, round trips, weekend holidays, family vacations, sightseeing, religious travel, and customized travel plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes travel from Pune to Igatpuri convenient and comfortable. Travelers can also customize their taxi itinerary to cover forts, temples, lakes, waterfalls, viewpoints, and nearby hill destinations according to their preferred schedule.",

topPlaces: [
  {
    title: "Igatpuri",
    description: "Igatpuri is a scenic hill destination in Maharashtra known for misty mountains, green valleys, pleasant weather, and peaceful surroundings. It is a popular choice for weekend trips and family getaways from Pune. Garud Cab Service provides comfortable private taxis with flexible pickup and drop arrangements for travelers planning a relaxed journey."
  },
  {
    title: "Tringalwadi Fort",
    description: "Tringalwadi Fort is a historic hill fort near Igatpuri surrounded by Sahyadri landscapes and offers scenic views for visitors interested in history and nature. The fort is also popular with trekking enthusiasts. Customers traveling from Pune can book a private taxi and include Tringalwadi in a customized Igatpuri sightseeing itinerary."
  },
  {
    title: "Bhavli Dam",
    description: "Bhavli Dam is a peaceful water destination near Igatpuri surrounded by hills and greenery. The area becomes particularly attractive during the monsoon season when the landscape turns lush and scenic. Garud Cab Service can arrange convenient taxi transportation from Pune for families and groups exploring Igatpuri's natural attractions."
  },
  {
    title: "Vihigaon Waterfall",
    description: "Vihigaon Waterfall is a popular monsoon attraction near Igatpuri known for its flowing cascade, rocky surroundings, and green landscapes. It is suitable for nature lovers, photographers, and adventure enthusiasts. Travelers can include the waterfall in their Pune to Igatpuri taxi itinerary with flexible sightseeing arrangements."
  },
  {
    title: "Kalsubai Peak",
    description: "Kalsubai Peak is the highest mountain peak in Maharashtra and is a popular destination for trekking and mountain enthusiasts. The surrounding Sahyadri scenery provides an excellent experience for adventure travelers. Customers can use a private taxi from Pune to reach the region comfortably and plan the journey around their trekking schedule."
  },
  {
    title: "Ghatandevi Temple",
    description: "Ghatandevi Temple is an important religious attraction near Igatpuri dedicated to Goddess Ghatandevi, regarded as the guardian deity of the mountain ghats. The temple is surrounded by scenic hills and peaceful surroundings. Garud Cab Service provides comfortable transportation for devotees and families traveling from Pune."
  },
  {
    title: "Vipassana International Academy",
    description: "Vipassana International Academy at Dhamma Giri in Igatpuri is internationally known as a meditation and Vipassana learning center. Visitors traveling for meditation programs may require dependable transportation with convenient pickup arrangements. Customers can book a private chauffeur-driven taxi from Pune according to their scheduled arrival and departure."
  },
  {
    title: "Camel Valley",
    description: "Camel Valley is a scenic viewpoint near Igatpuri known for deep valleys, waterfalls during the monsoon, and impressive Sahyadri landscapes. It is a popular stop for photographers and travelers exploring the area's natural beauty. Garud Cab Service can include Camel Valley in a customized sightseeing route from Pune."
  },
  {
    title: "Kasara Ghat",
    description: "Kasara Ghat is a scenic mountain pass surrounded by the Sahyadri ranges and is an important road and rail connection toward Mumbai. Travelers enjoy the winding roads and mountain scenery, particularly during the monsoon. Customers can comfortably travel through the region in a private taxi while exploring Igatpuri and nearby destinations."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a beautiful hill destination near Igatpuri known for Arthur Lake, waterfalls, mountains, forests, and peaceful natural surroundings. It is ideal for families, couples, and nature lovers planning an extended getaway. Customers can customize their Pune to Igatpuri taxi booking to include Bhandardara and other nearby attractions."
  }
],




"services": [
{
"name": "Pune to Igatpuri Cab",
"description": "Book Pune to Igatpuri Cab for comfortable and convenient travel from Pune to the scenic hill destination of Igatpuri. Professional chauffeurs and well-maintained AC vehicles make the service suitable for families, couples, tourists, weekend travelers, and individuals planning a private road journey."
},
{
"name": "Pune to Igatpuri Taxi",
"description": "Choose Pune to Igatpuri Taxi for a comfortable intercity journey with convenient pickup from your preferred Pune location. Sedan, SUV, Innova, and premium vehicle options can be arranged according to passenger count, luggage, and travel preferences."
},
{
"name": "Cab from Pune to Igatpuri",
"description": "Reserve a Cab from Pune to Igatpuri for direct private transportation with flexible pickup arrangements and professional chauffeur assistance. The service is suitable for families, couples, tourists, corporate travelers, and passengers planning a comfortable hill-region trip."
},
{
"name": "Taxi from Pune to Igatpuri",
"description": "Book a Taxi from Pune to Igatpuri for convenient chauffeur-driven transportation with comfortable AC interiors. The service is suitable for weekend getaways, family vacations, sightseeing trips, personal travel, and travelers looking for private transportation."
},
{
"name": "Pune to Igatpuri Cab Service",
"description": "Choose Pune to Igatpuri Cab Service for reliable private transportation with experienced drivers and comfortable vehicles. The service is suitable for families, couples, tourists, business travelers, and passengers planning a scenic long-distance journey."
},
{
"name": "Pune to Igatpuri Taxi Fare",
"description": "Check Pune to Igatpuri Taxi Fare according to the selected vehicle category, pickup location, journey type, and travel requirements. Sedan, SUV, Innova, and premium taxi options can be arranged for comfortable private travel."
},
{
"name": "Pune to Igatpuri One Way Cab",
"description": "Book Pune to Igatpuri One Way Cab for convenient point-to-point transportation without requiring a return booking. The service is suitable for hotel stays, personal visits, family travel, weekend trips, and passengers planning a one-way journey."
},
{
"name": "Pune to Igatpuri Round Trip Taxi",
"description": "Choose Pune to Igatpuri Round Trip Taxi for convenient travel with return transportation included in the journey plan. The service is suitable for weekend getaways, sightseeing, family vacations, couples, and travelers planning a scheduled return to Pune."
},
{
"name": "Pune to Igatpuri Cab Booking",
"description": "Make Pune to Igatpuri Cab Booking for scheduled private transportation with convenient vehicle selection and pickup arrangements. Sedan, SUV, Innova, and premium cars can be selected according to passenger count, luggage, travel timing, and comfort requirements."
},
{
"name": "Cheap Pune to Igatpuri Cab",
"description": "Book a Cheap Pune to Igatpuri Cab for economical private transportation with practical vehicle choices. The service is suitable for individuals, couples, families, students, tourists, and budget-conscious travelers planning a comfortable trip to Igatpuri."
},
{
"name": "Best Pune to Igatpuri Taxi",
"description": "Choose the Best Pune to Igatpuri Taxi for comfortable hill-region transportation supported by professional chauffeurs and well-maintained AC vehicles. The service is suitable for families, tourists, couples, corporate travelers, and groups planning a private journey."
},
{
"name": "Sedan Pune to Igatpuri Cab",
"description": "Book Sedan Pune to Igatpuri Cab for comfortable AC transportation suitable for individuals, couples, and small families. Sedan vehicles provide practical seating and luggage space for weekend trips, sightseeing, personal travel, and hill-station journeys."
},
{
"name": "SUV Pune to Igatpuri Taxi",
"description": "Choose SUV Pune to Igatpuri Taxi for spacious and comfortable transportation suitable for families and small groups. The vehicle offers additional seating and luggage capacity for sightseeing trips, weekend travel, and longer road journeys."
},
{
"name": "Innova Pune to Igatpuri Cab",
"description": "Book Innova Pune to Igatpuri Cab for spacious chauffeur-driven transportation suitable for families and groups. The vehicle provides comfortable seating and practical luggage capacity for sightseeing, family vacations, group travel, and private long-distance journeys."
},
{
"name": "Hill Drive Cab Pune Igatpuri",
"description": "Choose Hill Drive Cab Pune Igatpuri for comfortable private transportation through the scenic route to Igatpuri. Professional chauffeurs and well-maintained vehicles make the service suitable for families, couples, tourists, weekend travelers, and groups."
},
{
"name": "Pune to Igatpuri 24x7 Cab Service",
"description": "Book Pune to Igatpuri 24x7 Cab Service for flexible private transportation at different travel times. Comfortable chauffeur-driven vehicles can be arranged for early departures, late journeys, weekend trips, family travel, and planned sightseeing visits."
},
{
"name": "Outstation Cab Pune to Igatpuri",
"description": "Choose Outstation Cab Pune to Igatpuri for convenient private transportation outside Pune. Sedan, SUV, Innova, and larger vehicle options can be arranged for families, tourists, couples, business travelers, and groups planning a comfortable road journey."
},
{
"name": "Pune to Nashik Cab",
"description": "Book Pune to Nashik Cab for comfortable and convenient intercity transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for families, business travelers, tourists, devotees, and individuals traveling to Nashik for personal or professional purposes."
},
{
"name": "Pune to Nashik Cab Service",
"description": "Choose Pune to Nashik Cab Service for reliable chauffeur-driven transportation between Pune and Nashik. Comfortable vehicles can be arranged for family trips, business travel, sightseeing, religious visits, personal journeys, and long-distance transportation."
},
{
"name": "Pune to Nashik Taxi Service",
"description": "Book Pune to Nashik Taxi Service for convenient private travel with flexible pickup arrangements and professional drivers. Sedan, SUV, Innova, and premium options are suitable for individuals, families, tourists, corporate passengers, and groups."
},
{
"name": "Pune to Nashik Cab Booking",
"description": "Make Pune to Nashik Cab Booking for scheduled private transportation with convenient vehicle selection. Customers can arrange suitable cars according to passenger count, luggage, pickup time, journey type, and preferred travel comfort."
},
{
"name": "Best Pune to Nashik Cab",
"description": "Choose the Best Pune to Nashik Cab for comfortable intercity transportation supported by professional chauffeurs and well-maintained vehicles. The service is suitable for families, corporate travelers, tourists, devotees, and passengers planning private road travel."
},
{
"name": "One Way Pune to Nashik Cab",
"description": "Book One Way Pune to Nashik Cab for direct point-to-point transportation without requiring a return journey. The service is suitable for relocation, business visits, family travel, personal trips, sightseeing, and passengers staying in Nashik."
},
{
"name": "Round Trip Pune to Nashik Taxi",
"description": "Choose Round Trip Pune to Nashik Taxi for convenient transportation with return travel included in the journey plan. It is suitable for family visits, business meetings, sightseeing, religious trips, personal work, and travelers planning a scheduled return."
},
{
"name": "Cheap Pune to Nashik Cab",
"description": "Book a Cheap Pune to Nashik Cab for economical private transportation with practical vehicle options. Sedan and other suitable cars can be arranged for individuals, families, students, business travelers, tourists, and budget-conscious passengers."
},
{
"name": "Pune to Nashik Innova Crysta Cab",
"description": "Choose Pune to Nashik Innova Crysta Cab for premium and spacious intercity travel with comfortable interiors and professional chauffeur service. It is suitable for families, executives, corporate passengers, tourists, and groups seeking enhanced comfort."
},
{
"name": "Innova Crysta Cab Pune Nashik",
"description": "Book Innova Crysta Cab Pune Nashik for a spacious and refined road journey between the two cities. The vehicle is suitable for families, corporate travelers, groups, and passengers carrying additional luggage who prefer a premium travel experience."
},
{
"name": "Luxury Innova Crysta Pune Nashik",
"description": "Choose Luxury Innova Crysta Pune Nashik for premium chauffeur-driven transportation with spacious seating, comfortable interiors, AC travel, and practical luggage capacity. The service is suitable for executives, families, tourists, and special travel requirements."
},
{
"name": "Pune to Nashik Innova Cab",
"description": "Book Pune to Nashik Innova Cab for spacious and comfortable transportation suitable for families and small groups. The vehicle offers convenient seating and luggage capacity for business travel, sightseeing, religious visits, and personal journeys."
},
{
"name": "Innova Cab Service Pune Nashik",
"description": "Choose Innova Cab Service Pune Nashik for comfortable chauffeur-driven transportation between Pune and Nashik. The spacious vehicle is suitable for families, groups, corporate passengers, tourists, and travelers requiring additional luggage space."
},
{
"name": "Family Innova Taxi Pune Nashik",
"description": "Book Family Innova Taxi Pune Nashik for spacious private transportation designed for family journeys. Comfortable seating and luggage capacity make the vehicle suitable for family visits, sightseeing, religious trips, weekend travel, and longer road journeys."
},
{
"name": "Pune to Nashik Ertiga Cab",
"description": "Choose Pune to Nashik Ertiga Cab for comfortable group transportation with practical seating and luggage capacity. The vehicle is suitable for families, small groups, corporate travelers, and tourists looking for convenient long-distance travel."
},
{
"name": "Pune to Nashik Tempo Traveller",
"description": "Book Pune to Nashik Tempo Traveller for spacious group transportation with comfortable seating and luggage arrangements. The service is suitable for tourist groups, large families, corporate teams, pilgrimage groups, and friends traveling together."
},
{
"name": "Best Pune to Nashik Cab Service",
"description": "Choose Best Pune to Nashik Cab Service for convenient private transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for business travel, family journeys, tourism, sightseeing, religious visits, and personal trips."
},
{
"name": "Cheap Pune to Igatpuri Taxi",
"description": "Book Cheap Pune to Igatpuri Taxi for practical and economical transportation from Pune to Igatpuri. Suitable sedan and other vehicle options can be arranged for individuals, couples, families, tourists, and travelers planning a budget-friendly hill trip."
},
{
"name": "Pune to Trimbakeshwar Cab Online",
"description": "Book Pune to Trimbakeshwar Cab Online for convenient private transportation to the famous Trimbakeshwar pilgrimage destination. The service is suitable for devotees, families, senior passengers, and groups looking for comfortable chauffeur-driven travel from Pune."
},
{
"name": "Pune to Nashik Family Trip Cab",
"description": "Choose Pune to Nashik Family Trip Cab for spacious and comfortable private transportation for family journeys. Suitable vehicle options can accommodate passengers and luggage while providing convenient pickup, direct destination travel, and flexible trip arrangements."
}
],
"tableData": [
["Pune to Igatpuri Cab", "Pune to Igatpuri Taxi"],
["Cab from Pune to Igatpuri", "Taxi from Pune to Igatpuri"],
["Pune to Igatpuri Cab Service", "Pune to Igatpuri Taxi Fare"],
["Pune to Igatpuri One Way Cab", "Pune to Igatpuri Round Trip Taxi"],
["Pune to Igatpuri Cab Booking", "Cheap Pune to Igatpuri Cab"],
["Best Pune to Igatpuri Taxi", "Sedan Pune to Igatpuri Cab"],
["SUV Pune to Igatpuri Taxi", "Innova Pune to Igatpuri Cab"],
["Hill Drive Cab Pune Igatpuri", "Pune to Igatpuri 24x7 Cab Service"],
["Outstation Cab Pune to Igatpuri", "Pune to Nashik Cab"],
["Pune to Nashik Cab Service", "Pune to Nashik Taxi Service"],
["Pune to Nashik Cab Booking", "Best Pune to Nashik Cab"],
["One Way Pune to Nashik Cab", "Round Trip Pune to Nashik Taxi"],
["Cheap Pune to Nashik Cab", "Pune to Nashik Innova Crysta Cab"],
["Innova Crysta Cab Pune Nashik", "Luxury Innova Crysta Pune Nashik"],
["Pune to Nashik Innova Cab", "Innova Cab Service Pune Nashik"],
["Family Innova Taxi Pune Nashik", "Pune to Nashik Ertiga Cab"],
["Pune to Nashik Tempo Traveller", "Best Pune to Nashik Cab Service"],
["Cheap Pune to Igatpuri Taxi", "Pune to Trimbakeshwar Cab Online"],
["Pune to Nashik Family Trip Cab", "Pune to Igatpuri Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Igatpuri Taxi for a Comfortable Getaway",
    WhyChoosedescription: "A private taxi is a convenient choice for travellers heading from Pune to Igatpuri for a weekend break, family holiday, sightseeing plan, personal visit, or relaxed road trip."
  },
  {
    WhyChooseheading: "Convenient Pickup from Pune",
    WhyChoosedescription: "Your journey can start from a home, hotel, office, residential society, railway station area, or another preferred location in Pune, giving you flexibility when planning the departure."
  },
  {
    WhyChooseheading: "Direct Travel to Your Igatpuri Destination",
    WhyChoosedescription: "Passengers can travel directly to their selected hotel, resort, residence, or other accessible destination in Igatpuri without changing vehicles during the trip."
  },
  {
    WhyChooseheading: "Suitable for Families & Small Groups",
    WhyChoosedescription: "Families, couples, and groups can select a suitable taxi according to passenger count, luggage requirements, and comfort preferences for a convenient journey."
  },
  {
    WhyChooseheading: "Ideal for Weekend & Holiday Trips",
    WhyChoosedescription: "Igatpuri is a popular choice for short breaks and leisure travel, and a private taxi allows travellers to plan departure and return timings around their holiday itinerary."
  },
  {
    WhyChooseheading: "Convenient for Sightseeing Plans",
    WhyChoosedescription: "Travellers can use private transportation for planned sightseeing around Igatpuri and nearby attractions while keeping their travel schedule more flexible."
  },
  {
    WhyChooseheading: "One-Way & Round-Trip Options",
    WhyChoosedescription: "Choose a one-way taxi when only a direct drop is required, or arrange a round-trip vehicle when you want transportation back to Pune after completing your stay or sightseeing plan."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Pune pickup point, Igatpuri destination, travel date, passenger details, luggage requirements, preferred vehicle, and trip type with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Igatpuri Taxi Service?",
    answer: "Yes, Garud Cab Service provides private Pune to Igatpuri taxi services for families, couples, groups, tourists, weekend travellers, and passengers planning personal trips."
  },
  {
    question: "Can I book a one-way taxi from Pune to Igatpuri?",
    answer: "Yes, one-way taxi service can be arranged for passengers who need direct transportation from Pune to their preferred hotel, resort, residence, or destination in Igatpuri."
  },
  {
    question: "Can I book a round-trip taxi from Pune to Igatpuri?",
    answer: "Yes, round-trip taxi arrangements can be planned for weekend holidays, sightseeing trips, family outings, and other journeys requiring transportation back to Pune."
  },
  {
    question: "Is Pune to Igatpuri taxi suitable for families?",
    answer: "Yes, private taxi travel is suitable for families and groups who want to travel together with comfortable seating and convenient luggage arrangements."
  },
  {
    question: "Can I use the taxi for Igatpuri sightseeing?",
    answer: "Yes, private taxi transportation can be used for planned sightseeing around Igatpuri and nearby attractions according to your itinerary and travel duration."
  },
  {
    question: "Is Igatpuri suitable for a weekend trip from Pune?",
    answer: "Yes, Igatpuri can be considered for short holidays, weekend getaways, family outings, and leisure trips, with a private taxi providing convenient road transportation from Pune."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can I carry luggage in the Pune to Igatpuri taxi?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger luggage requirements should be communicated during booking."
  },
  {
    question: "Can couples book a private taxi to Igatpuri?",
    answer: "Yes, couples can arrange a private taxi for weekend getaways, holidays, sightseeing trips, special occasions, and personal travel to Igatpuri."
  },
  {
    question: "How can I book a Pune to Igatpuri Taxi?",
    answer: "Share your Pune pickup location, Igatpuri destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Kulkarni",
    feedback: "We planned a weekend trip from Pune to Igatpuri with our family and chose a private taxi. The direct journey and flexible pickup made the trip convenient to organize.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Patil",
    feedback: "I arranged a Pune to Igatpuri taxi for a short holiday with friends. The private vehicle gave us the flexibility to manage our travel schedule and luggage comfortably.",
    rating: 5
  }
];
















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Igatpuri Taxi",
  "image": "https://garudcabs.com/assets/images/pune-to-igatpuri-taxi.webp",
  "description": "Book Pune to Igatpuri Taxi with Garud Cab for safe, comfortable, and reliable intercity travel. Get Pune to Igatpuri cab and taxi services for one way trips, round trips, weekend getaways, family travel, sightseeing, and outstation journeys. Choose from Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles with convenient pickup and drop facilities.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-igatpuri-taxi"
  }
};



  return (
    <div>



<Helmet>
  <title>Pune to Igatpuri Taxi | One Way & Round Trip Cab | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Igatpuri Taxi with Garud Cab for comfortable and reliable travel. Get one way, round trip, sightseeing, and weekend trip cab services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Pune to Igatpuri Cab, Pune to Igatpuri Taxi, Cab from Pune to Igatpuri, Taxi from Pune to Igatpuri, Pune to Igatpuri Cab Service, Pune to Igatpuri Taxi Fare, Pune to Igatpuri One Way Cab, Pune to Igatpuri Round Trip Taxi, Pune to Igatpuri Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/87.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolgatpuritaxi;